import { combineReducers } from 'redux'

import list from './list/slice'

const myReducer = combineReducers({
  list,
})

export default myReducer
